import { AiOutlineMenu } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import logo from "shared/assets/images/logos/dl.svg";

const Header = ({ showSider, actions, menu }) => {
  const groupedActions = actions.reduce((groups, action) => {
    const groupName = action.group || "default";
    if (!groups[groupName]) {
      groups[groupName] = [];
    }
    groups[groupName].push(action);
    return groups;
  }, {});

  return (
    <header className="header__area">
      <div className="wrapper">
        <div className="header__area--left">
          <span onClick={showSider} className="toggle">
            <AiOutlineMenu size={24} color="#15357a" />
          </span>
          <img src={logo} alt="" />
          <div className="--divider"></div>
          <ul className="nav--menu">
            {menu.map((item) => (
              <li key={item.id}>
                <NavLink to={item.to} end>
                  {item.element}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="header__area--right">
          <div className="actions">
            {groupedActions["quick-actions"] && (
              <div className="actions--group quick-actions">
                <div className="actions--group--content">
                  {groupedActions["quick-actions"].map((action, index) => (
                    <div
                      key={`quick-${index}`}
                      className={`actions--group--item action-${action.type}`}
                    >
                      <action.component />
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="--divider"></div>
            {groupedActions["user-actions"] && (
              <div className="actions--group user-actions">
                <div className="actions--group--content">
                  {groupedActions["user-actions"].map((action, index) => (
                    <div
                      key={`user-${index}`}
                      className={`actions--group--item action-${action.type}`}
                    >
                      <action.component />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {groupedActions["default"] &&
              groupedActions["default"].map((action, index) => (
                <div
                  key={`default-${index}`}
                  className={`actions--group--item action-${action.type}`}
                >
                  <action.component />
                </div>
              ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
